import { prop, pipe, both, not } from 'ramda';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import coreActions from '../../actions';
import NavbarItem from './NavbarItem';
import { trackHeaderClick } from '../../services/tracking';

const shouldShowModal = pipe(
  getPOSData,
  both(pipe(prop('standAlone'), not), prop('limitExceeded')),
);

const configureHandlers = withHandlers({
  handleClick: ({
    adId, listId, pointOfSale, funnelId,
  }) => (btnName) => {
    trackHeaderClick(adId, listId, pointOfSale, btnName, funnelId);
  },
});

const mapStateToProps = (state) => {
  const posData = getPOSData(state);

  return {
    pointOfSale: prop('name', posData),
    funnelId: prop('funnelId', posData),
    adId: prop('adId', posData),
    listId: prop('listId', posData),
    shouldShowModal: shouldShowModal(state),
  };
};

export default compose(
  connect(mapStateToProps, coreActions),
  configureHandlers,
)(NavbarItem);
